module.exports = __webpack_public_path__ + "static/media/puzzle05.ad445ba1.png";